/** Admin display helpers — must match api/utils/withdrawCashback.js math. */

export function withdrawGrossAmount(w) {
  const gross = Number(w?.withdrawGrossAmount);
  if (Number.isFinite(gross) && gross > 0) return gross;
  return Number(w?.amount || 0);
}

export function withdrawPayoutAmount(w) {
  const gross = withdrawGrossAmount(w);
  const cashback = Number(w?.withdrawCashbackAmount || 0);
  const net = Number(w?.withdrawNetPaidAmount);
  if (Number.isFinite(net) && net >= 0 && (cashback > 0 || (gross > 0 && net < gross))) {
    return net;
  }
  if (cashback > 0 && gross > 0) return Math.max(0, gross - cashback);
  return gross;
}

export function hasWithdrawCashback(w) {
  return Number(w?.withdrawCashbackAmount || 0) > 0;
}

export function withdrawCashbackHint(w) {
  const cashback = Number(w?.withdrawCashbackAmount || 0);
  if (cashback <= 0) return null;
  const gross = withdrawGrossAmount(w);
  const net = withdrawPayoutAmount(w);
  return `Requested ₹${gross.toLocaleString("en-IN")} · Pay ₹${net.toLocaleString("en-IN")} · ₹${cashback.toLocaleString("en-IN")} cashback to wallet on success`;
}
